// extracted by mini-css-extract-plugin
export default {"latest-news":"LatestNews_latest-news__49JoR","title":"LatestNews_title__VdKr3"};